import {
  OnInit,
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  StaffEventBusinessPersonAudit,
  StaffEventBusinessPersonSkeleton
} from '../../+models/staff-event-audit.model';

@Component({
  selector: 'sd-portal-staff-event-business-person-audit-list',
  templateUrl: './staff-event-business-person-audit-list.component.html',
  styleUrls: ['./staff-event-business-person-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaffEventBusinessPersonAuditListComponent implements OnInit {
  @Input() staffEventBusinessPerson: StaffEventBusinessPersonSkeleton;
  @Input() loading: boolean;
  @Input() staffEventBusinessPersonAudits: StaffEventBusinessPersonAudit[];

  @Output() loadStaffEventBusinessPerson = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadStaffEventBusinessPerson.emit(
      this.staffEventBusinessPerson.staffEventBusinessPersonId
    );
  }

  onNextPage() {
    this.nextPage.emit(this.staffEventBusinessPerson.staffEventBusinessPersonId);
  }
}
